import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Search } from "lucide-react";
import { toast } from "sonner";
import { lookupCep, maskCep, formatAddress } from "@/lib/viacep";

/**
 * Compact CEP finder that renders inline. On Enter/blur/search click, it
 * queries ViaCEP and calls `onFound(oneLineAddress)` so the parent can
 * shove it into its `client_address` field. Cheap to add anywhere.
 */
export default function CepField({ onFound, size = "sm", disabled = false }) {
  const [cep, setCep] = useState("");
  const [num, setNum] = useState("");
  const [loading, setLoading] = useState(false);

  const doLookup = async () => {
    if ((cep.replace(/\D/g, "") || "").length !== 8) { toast.error("Informe um CEP com 8 dígitos"); return; }
    setLoading(true);
    try {
      const res = await lookupCep(cep);
      if (!res) { toast.error("CEP não encontrado"); return; }
      const line = formatAddress(res, num);
      onFound?.(line, res);
      toast.success("Endereço preenchido");
    } finally { setLoading(false); }
  };

  return (
    <div className="grid grid-cols-[110px_1fr_auto] gap-2 items-end">
      <div>
        <Input
          data-testid="input-cep"
          value={cep}
          onChange={(e) => setCep(maskCep(e.target.value))}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); doLookup(); } }}
          placeholder="CEP"
          className={size === "sm" ? "h-9 text-sm" : ""}
          inputMode="numeric"
          disabled={disabled || loading}
        />
      </div>
      <div>
        <Input
          data-testid="input-cep-number"
          value={num}
          onChange={(e) => setNum(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); doLookup(); } }}
          placeholder="Número (opcional)"
          className={size === "sm" ? "h-9 text-sm" : ""}
          disabled={disabled || loading}
        />
      </div>
      <Button data-testid="btn-cep-lookup" type="button" size={size} onClick={doLookup} disabled={disabled || loading}>
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Search className="h-4 w-4 mr-1" /> Buscar</>}
      </Button>
    </div>
  );
}
